import request from '@/utils/request'

export function index(data) {
  return request({
    url: 'index',
    method: 'post',
    data
  })
}

export function captcha(data) {
  return request({
    url: 'captcha',
    method: 'post',
    data
  })
}
export function login(data) {
  return request({
    url: 'login',
    method: 'post',
    data
  })
}
export function article(data) {
  return request({
    url: 'article',
    method: 'post',
    data
  })
}
export function articleInfo(data) {
  return request({
    url: 'article/info',
    method: 'post',
    data
  })
}
export function resIndex(data) {
  return request({
    url: 'res/index',
    method: 'post',
    data
  })
}
export function resGetNoUserAttachment(data) {
  return request({
    url: 'res/getNoUserAttachment',
    method: 'post',
    data
  })
}
export function resAdd(data) {
  return request({
    url: 'res/add',
    method: 'post',
    data
  })
}
export function resMy(data) {
  return request({
    url: 'res/my',
    method: 'post',
    data
  })
}
export function resInfo(data) {
  return request({
    url: 'res/info',
    method: 'post',
    data
  })
}

export function resDelete(data) {
  return request({
    url: 'res/delete',
    method: 'post',
    data
  })
}
export function resGetUploadConfig(data) {
  return request({
    url: 'user/getUploadConfig',
    method: 'post',
    data
  })
}
export function attachmentAdd(data) {
  return request({
    url: 'user/attachmentAdd',
    method: 'post',
    data
  })
}
export function attachmentDelete(data) {
  return request({
    url: 'user/attachmentDelete',
    method: 'post',
    data
  })
}


export function resourceGetConfig(data) {
  return request({
    url: 'campus/app/resource/config',
    method: 'post',
    data
  })
}
export function resourceAdd(data) {
  return request({
    url: 'campus/app/resource/add',
    method: 'post',
    data
  })
}
export function resourceAddLogs(data) {
  return request({
    url: 'campus/app/resource/add/logs',
    method: 'post',
    data
  })
}
export function resourceIndex(data) {
  return request({
    url: 'campus/app/resource/index',
    method: 'post',
    data
  })
}
export function resourceInfo(data) {
  return request({
    url: 'campus/app/resource/info',
    method: 'post',
    data
  })
}
export function resourceMy(data) {
  return request({
    url: 'campus/app/resource/my',
    method: 'post',
    data
  })
}
export function resourceDelete(data) {
  return request({
    url: 'campus/app/resource/delete',
    method: 'post',
    data
  })
}
export function aetherUploadPreprocess(data) {
  return request({
    url: 'campus/app/aetherupload/preprocess',
    method: 'post',
    data
  })
}
export function getNoUserAttachment(data) {
  return request({
    url: 'campus/app/resource/nouser/attachment',
    method: 'post',
    data
  })
}
export function deleteAttachment(data) {
  return request({
    url: 'campus/app/resource/delete/attachment',
    method: 'post',
    data
  })
}